export const FETCH_REGISTRATION_SETTING = 'FETCH_REGISTRATION_SETTING';
export const CREATE_REGISTRATION_SETTING = 'CREATE_REGISTRATION_SETTING';
export const UPDATE_REGISTRATION_SETTING = 'UPDATE_REGISTRATION_SETTING';